module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"from":"From","to":"to","on":"On","hours":"hours","fees":"Admission fee","event-free":"Free","level":"Level","hosts":"Host","place":"Location","get-there":"Getting there"},"fr":{"from":"Du","to":"au","on":"Le","hours":"heures","fees":"Tarif","event-free":"Gratuit","level":"Niveau","hosts":"Intervenant(s)","place":"Lieu","get-there":"S\u0027y rendre"}}')
  delete Component.options._Ctor
}
